import { IconDeviceLaptop } from "@repo/ui/icons";
import { DiagramSlide, type StepDef } from "./DiagramSlide";
import type { NodeDef } from "@components/architecture-data";

const DEVELOPER_NODE: NodeDef = {
  id: "developer",
  color: "violet",
  icon: IconDeviceLaptop,
  label: "Developer",
  desc: "",
  x: 1540,
  y: 88,
  layers: ["all"],
};

const STEPS: StepDef[] = [
  {
    key: "connect",
    label: "Connect",
    nodes: new Set(["developer", "webconsole", "cpapi"]),
    arrows: [
      { from: "developer", to: "webconsole", color: "#a78bfa" },
      { from: "webconsole", to: "cpapi", color: "#60a5fa" },
    ],
    caption: "All inbound connections flow through API",
  },
  {
    key: "authenticate",
    label: "Authenticate",
    nodes: new Set(["cpapi", "auth", "groupapp", "sso", "idp"]),
    arrows: [
      { from: "cpapi", to: "auth", color: "#60a5fa" },
      { from: "auth", to: "groupapp", color: "#22d3ee" },
      { from: "groupapp", to: "sso", color: "#fb923c" },
      { from: "sso", to: "idp", color: "#a78bfa" },
    ],
    caption:
      "Authentication via your SSO, already connected to GitLab",
  },
  {
    key: "authorize",
    label: "Authorize",
    nodes: new Set(["developer", "emulators", "cpapi", "auth"]),
    arrows: [
      { from: "developer", to: "emulators", color: "#a78bfa" },
      { from: "emulators", to: "cpapi", color: "#60a5fa" },
      { from: "cpapi", to: "auth", color: "#60a5fa" },
    ],
    caption:
      "Fine-grained roles and rights managed by admins",
  },
];

export function AuthenticationSlide() {
  return (
    <DiagramSlide
      title="Authentication + Authorization"
      subtitle="OIDC-based identity flow with federated SSO and role-based access control"
      steps={STEPS}
      extraNodes={[DEVELOPER_NODE]}
    />
  );
}
